import {
	accountingPeriodConstants
}from "./constants"
import actions from '../../actions'

const initialState = {
	list      : null,
	error     : null,
	isSending : false,
	changed   : null
}

export default function (state = initialState, action){
	switch (action.type){
		case accountingPeriodConstants.GetList.REQUEST:
		case accountingPeriodConstants.GetPaged.REQUEST:
		case accountingPeriodConstants.Create.REQUEST:
		case accountingPeriodConstants.Delete.REQUEST:
		case accountingPeriodConstants.Change.REQUEST:
			return {
				...state,
				isSending : true,
				changed   : null
			}
		case accountingPeriodConstants.GetList.FAILURE:
		case accountingPeriodConstants.GetPaged.FAILURE:
		case accountingPeriodConstants.Create.FAILURE:
		case accountingPeriodConstants.Delete.FAILURE:
		case accountingPeriodConstants.Change.FAILURE:
			return {
				...state,
				error     : action.payload,
				isSending : false
			}
		case accountingPeriodConstants.GetList.SUCCESS:
			return {
				...state,
				list      : action.payload.result,
				isSending : false
			}
		case accountingPeriodConstants.GetPaged.SUCCESS:
			return {
				...state,
				isSending : false,
				paged     : action.payload.result
			}
		case accountingPeriodConstants.Create.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.create : null
			}
		case accountingPeriodConstants.Delete.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.delete : null
			}
		case accountingPeriodConstants.Change.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.update : null
			}
		case (accountingPeriodConstants.CLEAR):
			return {
				...state,
				list                   : null,
				listReAccountingPeriod : null,
				error                  : null,
				isSending              : false
			}
		default:
			return state
	}
}